import { faqItems } from '@/mocks/home';

export default function SectionFaq() {
  return (
    <section id="faq" className="py-10 md:py-14 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="max-w-[800px] mx-auto">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-6 text-center">
            <i className="ri-question-answer-line text-primary-500 mr-2"></i>
            常见问答
          </h2>
          <div className="space-y-3">
            {faqItems.map((item, idx) => (
              <details key={idx} className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden">
                <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 pr-4">
                    {item.q}
                  </h3>
                  <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-background-200 text-foreground-500 text-xs transition-transform duration-200 group-open:rotate-180">
                    <i className="ri-arrow-down-s-line"></i>
                  </span>
                </summary>
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}